/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onChatPostCreated = /* GraphQL */ `
  subscription OnChatPostCreated($chatThreadId: ID!) {
    onChatPostCreated(chatThreadId: $chatThreadId) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onChatPostUpdated = /* GraphQL */ `
  subscription OnChatPostUpdated($chatThreadId: ID!) {
    onChatPostUpdated(chatThreadId: $chatThreadId) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onChatPostDeleted = /* GraphQL */ `
  subscription OnChatPostDeleted($chatThreadId: ID!) {
    onChatPostDeleted(chatThreadId: $chatThreadId) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onNotificationCreated = /* GraphQL */ `
  subscription OnNotificationCreated {
    onNotificationCreated {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onTicketCreated = /* GraphQL */ `
  subscription OnTicketCreated(
    $ticketType: Int!
    $affiliationOrganization: ID!
    $affiliationProject: ID
  ) {
    onTicketCreated(
      ticketType: $ticketType
      affiliationOrganization: $affiliationOrganization
      affiliationProject: $affiliationProject
    ) {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const onTicketUpdated = /* GraphQL */ `
  subscription OnTicketUpdated {
    onTicketUpdated {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const onUserProjectCreated = /* GraphQL */ `
  subscription OnUserProjectCreated($projectId: ID!) {
    onUserProjectCreated(projectId: $projectId) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUserProjectDeleted = /* GraphQL */ `
  subscription OnUserProjectDeleted($projectId: ID!) {
    onUserProjectDeleted(projectId: $projectId) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUserDeleted = /* GraphQL */ `
  subscription OnUserDeleted($id: ID!) {
    onUserDeleted(id: $id) {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const onUserProjectDeletedByUserId = /* GraphQL */ `
  subscription OnUserProjectDeletedByUserId($id2: ID!) {
    onUserProjectDeletedByUserId(id2: $id2) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onProjectUpdated = /* GraphQL */ `
  subscription OnProjectUpdated($id: ID!) {
    onProjectUpdated(id: $id) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCorporationUpdated = /* GraphQL */ `
  subscription OnCorporationUpdated($id: ID!) {
    onCorporationUpdated(id: $id) {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const onGetNotificationByFilter = /* GraphQL */ `
  subscription OnGetNotificationByFilter($filter: String) {
    onGetNotificationByFilter(filter: $filter) {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onChatPostCreatedForAnonymousUser = /* GraphQL */ `
  subscription OnChatPostCreatedForAnonymousUser($chatThreadId: ID!) {
    onChatPostCreatedForAnonymousUser(chatThreadId: $chatThreadId) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onChatPostUpdatedForAnonymous = /* GraphQL */ `
  subscription OnChatPostUpdatedForAnonymous($chatThreadId: ID!) {
    onChatPostUpdatedForAnonymous(chatThreadId: $chatThreadId) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onChatPostDeletedForAnonymous = /* GraphQL */ `
  subscription OnChatPostDeletedForAnonymous($chatThreadId: ID!) {
    onChatPostDeletedForAnonymous(chatThreadId: $chatThreadId) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onAIChatPostCreated = /* GraphQL */ `
  subscription OnAIChatPostCreated($chatThreadId: ID!) {
    onAIChatPostCreated(chatThreadId: $chatThreadId) {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
    }
  }
`;
export const onTaskParentUpdated = /* GraphQL */ `
  subscription OnTaskParentUpdated($id: ID!) {
    onTaskParentUpdated(id: $id) {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onStreamMessageChatAIResponse = /* GraphQL */ `
  subscription OnStreamMessageChatAIResponse($aiChatPostId: String!) {
    onStreamMessageChatAIResponse(aiChatPostId: $aiChatPostId) {
      message
      aiChatPostId
      seq
      isEnd
      postType
    }
  }
`;
export const onPersonalConnectorServiceUpdated = /* GraphQL */ `
  subscription OnPersonalConnectorServiceUpdated($ownerBy: ID!) {
    onPersonalConnectorServiceUpdated(ownerBy: $ownerBy) {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onMCPServiceUpdatedByOwner = /* GraphQL */ `
  subscription OnMCPServiceUpdatedByOwner($ownerBy: String!) {
    onMCPServiceUpdatedByOwner(ownerBy: $ownerBy) {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onChatThreadUpdate = /* GraphQL */ `
  subscription OnChatThreadUpdate($id: ID!) {
    onChatThreadUpdate(id: $id) {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const onTranslationJobUpdated = /* GraphQL */ `
  subscription OnTranslationJobUpdated($affiliationOrganization: String!) {
    onTranslationJobUpdated(affiliationOrganization: $affiliationOrganization) {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateAIChatPost = /* GraphQL */ `
  subscription OnCreateAIChatPost {
    onCreateAIChatPost {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
    }
  }
`;
export const onUpdateAIChatPost = /* GraphQL */ `
  subscription OnUpdateAIChatPost {
    onUpdateAIChatPost {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
    }
  }
`;
export const onDeleteAIChatPost = /* GraphQL */ `
  subscription OnDeleteAIChatPost {
    onDeleteAIChatPost {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
    }
  }
`;
export const onCreateAIChatThread = /* GraphQL */ `
  subscription OnCreateAIChatThread {
    onCreateAIChatThread {
      id
      corporationId
      affiliationProject
      chatThreadId
      optionSearch {
        methodSearch
        attributeSearch
        keywordList
        fromSearchDate
        toSearchDate
        formatSearch
        sortType
      }
      drillDownSearch {
        ticketType
        creator
        updator
        proxiedUser
        suffixOfAttachments
        form
        tagFields {
          fieldId
          fieldItemId
        }
        statusFields {
          fieldId
          fieldItemId
        }
        publicRange
        sharedBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
        privateBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
      }
      clientUUId
      ticketId
      chatThreadType
      status
      metaData {
        filterKnowledgeListData
      }
      aiLogMetaData
      createdAt
      updatedAt
      startTime
      endTime
      creatorId
      updatorId
    }
  }
`;
export const onUpdateAIChatThread = /* GraphQL */ `
  subscription OnUpdateAIChatThread {
    onUpdateAIChatThread {
      id
      corporationId
      affiliationProject
      chatThreadId
      optionSearch {
        methodSearch
        attributeSearch
        keywordList
        fromSearchDate
        toSearchDate
        formatSearch
        sortType
      }
      drillDownSearch {
        ticketType
        creator
        updator
        proxiedUser
        suffixOfAttachments
        form
        tagFields {
          fieldId
          fieldItemId
        }
        statusFields {
          fieldId
          fieldItemId
        }
        publicRange
        sharedBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
        privateBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
      }
      clientUUId
      ticketId
      chatThreadType
      status
      metaData {
        filterKnowledgeListData
      }
      aiLogMetaData
      createdAt
      updatedAt
      startTime
      endTime
      creatorId
      updatorId
    }
  }
`;
export const onDeleteAIChatThread = /* GraphQL */ `
  subscription OnDeleteAIChatThread {
    onDeleteAIChatThread {
      id
      corporationId
      affiliationProject
      chatThreadId
      optionSearch {
        methodSearch
        attributeSearch
        keywordList
        fromSearchDate
        toSearchDate
        formatSearch
        sortType
      }
      drillDownSearch {
        ticketType
        creator
        updator
        proxiedUser
        suffixOfAttachments
        form
        tagFields {
          fieldId
          fieldItemId
        }
        statusFields {
          fieldId
          fieldItemId
        }
        publicRange
        sharedBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
        privateBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
      }
      clientUUId
      ticketId
      chatThreadType
      status
      metaData {
        filterKnowledgeListData
      }
      aiLogMetaData
      createdAt
      updatedAt
      startTime
      endTime
      creatorId
      updatorId
    }
  }
`;
export const onCreateAttachFile = /* GraphQL */ `
  subscription OnCreateAttachFile {
    onCreateAttachFile {
      id
      shortKey
      attachBy
      relatedId
      originId
      affiliationOrganization
      affiliationProject
      s3Path
      fileInfo
      thumbnailInfo
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAttachFile = /* GraphQL */ `
  subscription OnUpdateAttachFile {
    onUpdateAttachFile {
      id
      shortKey
      attachBy
      relatedId
      originId
      affiliationOrganization
      affiliationProject
      s3Path
      fileInfo
      thumbnailInfo
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAttachFile = /* GraphQL */ `
  subscription OnDeleteAttachFile {
    onDeleteAttachFile {
      id
      shortKey
      attachBy
      relatedId
      originId
      affiliationOrganization
      affiliationProject
      s3Path
      fileInfo
      thumbnailInfo
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const onCreateBookmark = /* GraphQL */ `
  subscription OnCreateBookmark {
    onCreateBookmark {
      id
      affiliationOrganization
      affiliationProject
      name
      definition
      shareRange
      defaultBookmark
      creator
      createdAt
      updator
      updatedAt
      targetType
    }
  }
`;
export const onUpdateBookmark = /* GraphQL */ `
  subscription OnUpdateBookmark {
    onUpdateBookmark {
      id
      affiliationOrganization
      affiliationProject
      name
      definition
      shareRange
      defaultBookmark
      creator
      createdAt
      updator
      updatedAt
      targetType
    }
  }
`;
export const onDeleteBookmark = /* GraphQL */ `
  subscription OnDeleteBookmark {
    onDeleteBookmark {
      id
      affiliationOrganization
      affiliationProject
      name
      definition
      shareRange
      defaultBookmark
      creator
      createdAt
      updator
      updatedAt
      targetType
    }
  }
`;
export const onCreateCallHistory = /* GraphQL */ `
  subscription OnCreateCallHistory {
    onCreateCallHistory {
      id
      affiliationOrganization
      affiliationProject
      to
      callDirection
      callCategory
      metaData
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateCallHistory = /* GraphQL */ `
  subscription OnUpdateCallHistory {
    onUpdateCallHistory {
      id
      affiliationOrganization
      affiliationProject
      to
      callDirection
      callCategory
      metaData
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteCallHistory = /* GraphQL */ `
  subscription OnDeleteCallHistory {
    onDeleteCallHistory {
      id
      affiliationOrganization
      affiliationProject
      to
      callDirection
      callCategory
      metaData
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateChatPost = /* GraphQL */ `
  subscription OnCreateChatPost {
    onCreateChatPost {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onUpdateChatPost = /* GraphQL */ `
  subscription OnUpdateChatPost {
    onUpdateChatPost {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onDeleteChatPost = /* GraphQL */ `
  subscription OnDeleteChatPost {
    onDeleteChatPost {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const onCreateChatThread = /* GraphQL */ `
  subscription OnCreateChatThread {
    onCreateChatThread {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const onUpdateChatThread = /* GraphQL */ `
  subscription OnUpdateChatThread {
    onUpdateChatThread {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const onDeleteChatThread = /* GraphQL */ `
  subscription OnDeleteChatThread {
    onDeleteChatThread {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const onCreateContract = /* GraphQL */ `
  subscription OnCreateContract {
    onCreateContract {
      id
      affiliationOrganization
      productId
      editionId
      versionId
      kind
      paymentStatus
      paymentMethod
      paymentCycle
      currentPaymentCycle
      paymentDate
      price
      contractStatus
      additionalUpgradeSetting
      additionalPrivateSetting
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      metaData
      trialDays
      startDate
      billStartDate
      billEndDate
      endTrialDate
      createdAt
      updatedAt
      creator
      updator
    }
  }
`;
export const onUpdateContract = /* GraphQL */ `
  subscription OnUpdateContract {
    onUpdateContract {
      id
      affiliationOrganization
      productId
      editionId
      versionId
      kind
      paymentStatus
      paymentMethod
      paymentCycle
      currentPaymentCycle
      paymentDate
      price
      contractStatus
      additionalUpgradeSetting
      additionalPrivateSetting
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      metaData
      trialDays
      startDate
      billStartDate
      billEndDate
      endTrialDate
      createdAt
      updatedAt
      creator
      updator
    }
  }
`;
export const onDeleteContract = /* GraphQL */ `
  subscription OnDeleteContract {
    onDeleteContract {
      id
      affiliationOrganization
      productId
      editionId
      versionId
      kind
      paymentStatus
      paymentMethod
      paymentCycle
      currentPaymentCycle
      paymentDate
      price
      contractStatus
      additionalUpgradeSetting
      additionalPrivateSetting
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      metaData
      trialDays
      startDate
      billStartDate
      billEndDate
      endTrialDate
      createdAt
      updatedAt
      creator
      updator
    }
  }
`;
export const onCreateCorporation = /* GraphQL */ `
  subscription OnCreateCorporation {
    onCreateCorporation {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const onUpdateCorporation = /* GraphQL */ `
  subscription OnUpdateCorporation {
    onUpdateCorporation {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const onDeleteCorporation = /* GraphQL */ `
  subscription OnDeleteCorporation {
    onDeleteCorporation {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const onCreateExternalAPI = /* GraphQL */ `
  subscription OnCreateExternalAPI {
    onCreateExternalAPI {
      id
      affiliationOrganization
      affiliationProject
      ownerBy
      connectId
      serviceName
      baseURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      baseSetting {
        userName
        password
        apiKeyValue
        metaData
      }
      apiOverview
      inputParamDesc
      outputFormat
      testURL
      testParam
      testResult
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onUpdateExternalAPI = /* GraphQL */ `
  subscription OnUpdateExternalAPI {
    onUpdateExternalAPI {
      id
      affiliationOrganization
      affiliationProject
      ownerBy
      connectId
      serviceName
      baseURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      baseSetting {
        userName
        password
        apiKeyValue
        metaData
      }
      apiOverview
      inputParamDesc
      outputFormat
      testURL
      testParam
      testResult
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onDeleteExternalAPI = /* GraphQL */ `
  subscription OnDeleteExternalAPI {
    onDeleteExternalAPI {
      id
      affiliationOrganization
      affiliationProject
      ownerBy
      connectId
      serviceName
      baseURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      baseSetting {
        userName
        password
        apiKeyValue
        metaData
      }
      apiOverview
      inputParamDesc
      outputFormat
      testURL
      testParam
      testResult
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onCreateForms = /* GraphQL */ `
  subscription OnCreateForms {
    onCreateForms {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      multiActionTime
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      usingTicket
      usedProject
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
      hideInProject
      autoTranslateAttachment
      translateSourceLang
      translateTargetLangs
    }
  }
`;
export const onUpdateForms = /* GraphQL */ `
  subscription OnUpdateForms {
    onUpdateForms {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      multiActionTime
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      usingTicket
      usedProject
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
      hideInProject
      autoTranslateAttachment
      translateSourceLang
      translateTargetLangs
    }
  }
`;
export const onDeleteForms = /* GraphQL */ `
  subscription OnDeleteForms {
    onDeleteForms {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      multiActionTime
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      usingTicket
      usedProject
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
      hideInProject
      autoTranslateAttachment
      translateSourceLang
      translateTargetLangs
    }
  }
`;
export const onCreateMCPCatalog = /* GraphQL */ `
  subscription OnCreateMCPCatalog {
    onCreateMCPCatalog {
      id
      usage
      parentId
      version
      mcpName
      mcpPackageName
      mcpPackageVersion
      mcpType
      mcpStatus
      description
      purpose
      supportedOS
      downloadURL
      prerequisites
      systemPrompt
      releaseNotes
      requiredEnv
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateMCPCatalog = /* GraphQL */ `
  subscription OnUpdateMCPCatalog {
    onUpdateMCPCatalog {
      id
      usage
      parentId
      version
      mcpName
      mcpPackageName
      mcpPackageVersion
      mcpType
      mcpStatus
      description
      purpose
      supportedOS
      downloadURL
      prerequisites
      systemPrompt
      releaseNotes
      requiredEnv
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteMCPCatalog = /* GraphQL */ `
  subscription OnDeleteMCPCatalog {
    onDeleteMCPCatalog {
      id
      usage
      parentId
      version
      mcpName
      mcpPackageName
      mcpPackageVersion
      mcpType
      mcpStatus
      description
      purpose
      supportedOS
      downloadURL
      prerequisites
      systemPrompt
      releaseNotes
      requiredEnv
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateMCPServer = /* GraphQL */ `
  subscription OnCreateMCPServer {
    onCreateMCPServer {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onUpdateMCPServer = /* GraphQL */ `
  subscription OnUpdateMCPServer {
    onUpdateMCPServer {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onDeleteMCPServer = /* GraphQL */ `
  subscription OnDeleteMCPServer {
    onDeleteMCPServer {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification {
    onCreateNotification {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification {
    onUpdateNotification {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteNotification = /* GraphQL */ `
  subscription OnDeleteNotification {
    onDeleteNotification {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct {
    onCreateProduct {
      id
      productId
      editionId
      name
      order
      metaData
      increaseRate
      usage
      status
      isTrial
      moduleSetting
      creator
      createdAt
      updator
      aiBasicPrompt
      updatedAt
      deletedAt
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct {
    onUpdateProduct {
      id
      productId
      editionId
      name
      order
      metaData
      increaseRate
      usage
      status
      isTrial
      moduleSetting
      creator
      createdAt
      updator
      aiBasicPrompt
      updatedAt
      deletedAt
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct {
    onDeleteProduct {
      id
      productId
      editionId
      name
      order
      metaData
      increaseRate
      usage
      status
      isTrial
      moduleSetting
      creator
      createdAt
      updator
      aiBasicPrompt
      updatedAt
      deletedAt
    }
  }
`;
export const onCreateProject = /* GraphQL */ `
  subscription OnCreateProject {
    onCreateProject {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateProject = /* GraphQL */ `
  subscription OnUpdateProject {
    onUpdateProject {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteProject = /* GraphQL */ `
  subscription OnDeleteProject {
    onDeleteProject {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateQueue = /* GraphQL */ `
  subscription OnCreateQueue {
    onCreateQueue {
      id
      usage
      type
      status
      retry
      info
      planTime
      executeTime
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateQueue = /* GraphQL */ `
  subscription OnUpdateQueue {
    onUpdateQueue {
      id
      usage
      type
      status
      retry
      info
      planTime
      executeTime
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteQueue = /* GraphQL */ `
  subscription OnDeleteQueue {
    onDeleteQueue {
      id
      usage
      type
      status
      retry
      info
      planTime
      executeTime
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSdeskToken = /* GraphQL */ `
  subscription OnCreateSdeskToken {
    onCreateSdeskToken {
      id
      tokenHash
      tokenType
      userId
      affiliationOrganization
      affiliationProject
      scopes
      status
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateSdeskToken = /* GraphQL */ `
  subscription OnUpdateSdeskToken {
    onUpdateSdeskToken {
      id
      tokenHash
      tokenType
      userId
      affiliationOrganization
      affiliationProject
      scopes
      status
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteSdeskToken = /* GraphQL */ `
  subscription OnDeleteSdeskToken {
    onDeleteSdeskToken {
      id
      tokenHash
      tokenType
      userId
      affiliationOrganization
      affiliationProject
      scopes
      status
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateShareLink = /* GraphQL */ `
  subscription OnCreateShareLink {
    onCreateShareLink {
      id
      shortKey
      targetId
      type
      targetAffiliationCorporationId
      targetAffiliationCorporationDomain
      targetAffiliationProjectId
      generateLinkCorporationId
      generateLinkCorporationDomain
      generateLinkProjectId
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShareLink = /* GraphQL */ `
  subscription OnUpdateShareLink {
    onUpdateShareLink {
      id
      shortKey
      targetId
      type
      targetAffiliationCorporationId
      targetAffiliationCorporationDomain
      targetAffiliationProjectId
      generateLinkCorporationId
      generateLinkCorporationDomain
      generateLinkProjectId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShareLink = /* GraphQL */ `
  subscription OnDeleteShareLink {
    onDeleteShareLink {
      id
      shortKey
      targetId
      type
      targetAffiliationCorporationId
      targetAffiliationCorporationDomain
      targetAffiliationProjectId
      generateLinkCorporationId
      generateLinkCorporationDomain
      generateLinkProjectId
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTask = /* GraphQL */ `
  subscription OnCreateTask {
    onCreateTask {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTask = /* GraphQL */ `
  subscription OnUpdateTask {
    onUpdateTask {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTask = /* GraphQL */ `
  subscription OnDeleteTask {
    onDeleteTask {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTicket = /* GraphQL */ `
  subscription OnCreateTicket {
    onCreateTicket {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const onUpdateTicket = /* GraphQL */ `
  subscription OnUpdateTicket {
    onUpdateTicket {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const onDeleteTicket = /* GraphQL */ `
  subscription OnDeleteTicket {
    onDeleteTicket {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const onCreateTranslationDictionary = /* GraphQL */ `
  subscription OnCreateTranslationDictionary {
    onCreateTranslationDictionary {
      id
      usage
      affiliationOrganization
      sourceLanguage
      targetLanguage
      status
      translationEngine
      sourceText
      sourceHash
      translatedText
      category
      useAsTerminology
      isUserDefined
      entryId
      translateId
      sourceType
      sourceId
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateTranslationDictionary = /* GraphQL */ `
  subscription OnUpdateTranslationDictionary {
    onUpdateTranslationDictionary {
      id
      usage
      affiliationOrganization
      sourceLanguage
      targetLanguage
      status
      translationEngine
      sourceText
      sourceHash
      translatedText
      category
      useAsTerminology
      isUserDefined
      entryId
      translateId
      sourceType
      sourceId
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteTranslationDictionary = /* GraphQL */ `
  subscription OnDeleteTranslationDictionary {
    onDeleteTranslationDictionary {
      id
      usage
      affiliationOrganization
      sourceLanguage
      targetLanguage
      status
      translationEngine
      sourceText
      sourceHash
      translatedText
      category
      useAsTerminology
      isUserDefined
      entryId
      translateId
      sourceType
      sourceId
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateTranslationJob = /* GraphQL */ `
  subscription OnCreateTranslationJob {
    onCreateTranslationJob {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateTranslationJob = /* GraphQL */ `
  subscription OnUpdateTranslationJob {
    onUpdateTranslationJob {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteTranslationJob = /* GraphQL */ `
  subscription OnDeleteTranslationJob {
    onDeleteTranslationJob {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateTranslationUsage = /* GraphQL */ `
  subscription OnCreateTranslationUsage {
    onCreateTranslationUsage {
      id
      affiliationOrganization
      yearMonth
      pageCount
      charCount
      onDemandChar
      jobCount
      billablePages
      billableChars
      creator
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTranslationUsage = /* GraphQL */ `
  subscription OnUpdateTranslationUsage {
    onUpdateTranslationUsage {
      id
      affiliationOrganization
      yearMonth
      pageCount
      charCount
      onDemandChar
      jobCount
      billablePages
      billableChars
      creator
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTranslationUsage = /* GraphQL */ `
  subscription OnDeleteTranslationUsage {
    onDeleteTranslationUsage {
      id
      affiliationOrganization
      yearMonth
      pageCount
      charCount
      onDemandChar
      jobCount
      billablePages
      billableChars
      creator
      createdAt
      updatedAt
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser {
    onDeleteUser {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const onCreateUserBookmark = /* GraphQL */ `
  subscription OnCreateUserBookmark {
    onCreateUserBookmark {
      id
      userId
      bookmarkId
      ticketId
      projectSetting
      bookmarkShareRange
      bookmarkAffiliationProject
      ticketAffiliationProject
      ticketAffiliationOrganization
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onUpdateUserBookmark = /* GraphQL */ `
  subscription OnUpdateUserBookmark {
    onUpdateUserBookmark {
      id
      userId
      bookmarkId
      ticketId
      projectSetting
      bookmarkShareRange
      bookmarkAffiliationProject
      ticketAffiliationProject
      ticketAffiliationOrganization
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onDeleteUserBookmark = /* GraphQL */ `
  subscription OnDeleteUserBookmark {
    onDeleteUserBookmark {
      id
      userId
      bookmarkId
      ticketId
      projectSetting
      bookmarkShareRange
      bookmarkAffiliationProject
      ticketAffiliationProject
      ticketAffiliationOrganization
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const onCreateView = /* GraphQL */ `
  subscription OnCreateView {
    onCreateView {
      id
      name
      affiliationOrganization
      affiliationProject
      affiliationView
      visibleRange
      visibleType
      structure
      viewType
      definitionView
      status
      order
      sortData
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateView = /* GraphQL */ `
  subscription OnUpdateView {
    onUpdateView {
      id
      name
      affiliationOrganization
      affiliationProject
      affiliationView
      visibleRange
      visibleType
      structure
      viewType
      definitionView
      status
      order
      sortData
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteView = /* GraphQL */ `
  subscription OnDeleteView {
    onDeleteView {
      id
      name
      affiliationOrganization
      affiliationProject
      affiliationView
      visibleRange
      visibleType
      structure
      viewType
      definitionView
      status
      order
      sortData
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
